import apiClient from './client';
import type {
  CompanyFinanceHealthResponse,
  CompanyFinanceOverview,
  CompanyFinanceReconcileRequest,
  CompanyFinanceReconcileResponse,
} from '@/types/companyFinance';

export const companyFinanceApi = {
  getHealth: (includeWriteProbe = true) =>
    apiClient
      .get<CompanyFinanceHealthResponse>('/company-finance/health', {
        params: {
          include_live_probe: true,
          include_write_probe: includeWriteProbe,
        },
      })
      .then((response) => response.data),

  getOverview: (period?: string) =>
    apiClient
      .get<CompanyFinanceOverview>('/company-finance/overview', {
        params: period ? { period } : undefined,
      })
      .then((response) => response.data),

  runReconciliation: (payload: CompanyFinanceReconcileRequest) =>
    apiClient
      .post<CompanyFinanceReconcileResponse>('/company-finance/reconcile', payload)
      .then((response) => response.data),
};
